<template>
  <div>
    <b-table
      v-if="!arrangeMode"
      id="table-transition-example"
      class="vgt-table bordered"
      :head-variant="headVariant"
      :items="listOfData"
      name="id"
      :fields="fields"
      responsive
      show-empty
      :tbody-transition-props="transProps"
      primary-key="id"
      :busy="loadingTable"
      @sort-changed="sortChanged"
      :no-sort-reset="true"
    >


      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            type="grow"
            label="Loading..."
            variant="primary"
          />
        </div>
      </template>

      <template
        v-for="(field,key) in fields"
        v-slot:[`cell(${field.key})`]="data"
      >
        <div :key="key">
          <b-avatar
            v-if="field.type=='image'"
            :src="$_.get(data.item, field.key) ? $_.get(data.item, field.key) : require('@/assets/images/user/default-user-image.png')"
            class="rounded-pill"
          />

            <div v-else-if="field.type == 'custom'">
                <slot :name="field.key" :data="data.item"></slot>
            </div>

          <strong v-else-if="field.type == 'status'">
            <mainstatus :status="$_.get(data.item, field.key)" />
          </strong>

          <div v-else-if="field.type == 'actions'">
            <cell-actions
              :showActionInList="showActionInList"
              :cell-actions="field"
              :data-item="data.item"
            />
          </div>

          <div v-else-if="field.type == 'promo'">
            <p class="m-0">
              <span v-if="$_.get(data.item, field.key) > 0">P ({{ $_.get(data.item, field.key) }})</span>
              <span v-else>NP</span>
            </p>
          </div>
          <div v-else-if="field.type == 'offer'">
            <p class="m-0" v-if="data.item.promotion_type === 'package'">{{ data.item.package }} for {{data.item.package_price_egp}} EGP</p>
            <p class="m-0" v-else-if="data.item.promotion_type === 'buy_x get_y'">Buy {{ data.item.buy_x }}, Get {{ data.item.get_y }}</p>
            <p class="m-0" v-else>{{ data.item.discount_price_egp }}%</p>
          </div>

          <div v-else-if="field.type == 'array'">
            <span v-if="field.array_keys" >
              <ul class="p-0">
                <li v-for="(value, key) in arrayCellValues(data.item, field).slice(0,4)" :key="key">
                  <span v-if="key==3">...</span>
                  <template v-else>{{ value }}</template>
                </li>
              </ul>
            </span>
            <span v-else>
              <span v-for="(arr, key) in $_.get(data.item, field.key).slice(0,3)" :key="key">
                {{ arr }}
                <span v-if="(key < 3)">,</span>
              </span>
            </span>
          </div>

          <div class="min-width-image-cell width-180px" v-else-if="field.type == 'multi_image'">
            <div class="iq-media-group position-relative">
              <b-link href="#" class="iq-media" v-for="(image, counter) in $_.get(data.item, field.key).slice(0,3)" :key="counter">
                <b-img class="avatar-40" rounded="circle" fluid :src="image.file" :alt="image.name" />
                <div v-if="($_.get(data.item, field.key).length > 3) && counter === 2" class="more-images text-white">{{ $_.get(data.item, field.key).length-3 }}+</div>
              </b-link>
            </div>
          </div>

          <div v-else-if="field.type == 'multi-text'">
            <span v-for="(arrKey, key) in field.key.split(',')" :key="key">
              <span v-if="$_.get(data.item, arrKey)">
                {{ $_.get(data.item, arrKey) }}
              </span>
            </span>
          </div>

          <div v-else-if="field.type == 'rate'">
                {{ $_.get(data.item, arrKey) ? $_.get(data.item, arrKey) : 0 }}
          </div>

          <div v-else-if="field.type == 'multi-currency'">
            <ul class="p-0">
              <li v-for="(arrKey, key) in field.key.split(',')" :key="key">
                <span v-if="arrKey.includes('egp')">
                    <span v-if="$_.get(data.item, arrKey)">EGP {{ $_.get(data.item, arrKey) }}</span>
                    <span v-else>N/A</span>
                  </span>
                <span v-else-if="arrKey.includes('euro')">
                    <span v-if="$_.get(data.item, 'price_euro')">
                      <span v-if="arrKey.includes('discount')&& !$_.get(data.item, arrKey)">
                        N/A
                      </span>
                      <span v-else>€ {{ $_.get(data.item, arrKey) }}</span>
                    </span>
                  </span>
                <span v-else-if="arrKey.includes('dollar')">
                    <span v-if="$_.get(data.item, 'price_dollar')">
                      <span v-if="arrKey.includes('discount')&& !$_.get(data.item, arrKey)">
                        N/A
                      </span>
                      <span v-else>$ {{ $_.get(data.item, arrKey) }}</span>
                    </span>
                  </span>
              </li>
            </ul>
          </div>

          <div v-else-if="field.type == 'birthDate'">
            {{ calculateAge($_.get(data.item, field.key)) }}
          </div>

          <div v-else-if="field.type == 'validity'">
            {{ dateDifference('', $_.get(data.item, field.key)) || '---' }}
          </div>

          <p
            v-else
            class="text-nowrap m-0"
          >
            <span v-if="$_.get(data.item, field.key)">
              {{ $_.get(data.item, field.key).length > limitOfChar ? $_.get(data.item, field.key).substring(0,limitOfChar) + '...' : $_.get(data.item, field.key) }}
            </span>
            <span v-else>
              ---
            </span>
          </p>
          
        </div>

      </template>

      <template v-slot:[`cell(#)`]="data">
        <div class="text-center">
          {{ pagination.from  + ( data.index ) }}
        </div>
      </template>

      <template v-slot:cell(change_status)="data">
        <changeStatus
            v-if="data.field.showIf ? data.field.showIf(): true"
            :allData = data
            :id="data.item.id"
            :type="data.field.tableType"
            :status="data.item.status"
            :statusKeyId="data.field.idKey"
            :post-key="data.field.postKey"
            @changeStatus="changeStatus"
        />
        <strong v-else>
          <mainstatus :status="data.item.status" />
        </strong>
      </template>
    </b-table>
    <div v-else class="table-responsive">
      <div v-if="loadingTable" class="text-center text-danger my-2">
        <b-spinner type="grow" label="Loading..." variant="primary" />
      </div>
      <div v-else>
        <table class="table vgt-table bordered mb-0">
          <thead>
            <tr>
              <th v-for="field in fields" :key="field.key" :class="field.class">
                {{ field.label }}
              </th>
            </tr>
          </thead>
          <draggable
            tag="tbody"
            :list="listOfData"
            handle=".drag-handle"
            ghost-class="dragging"
            :disabled="savingSort"
            @change="onDragChange"
          >
            <tr v-for="(item, index) in listOfData" :key="item.id || index" :class="item._rowVariant ? `table-${item._rowVariant}` : ''">
              <td v-for="(field, key) in fields" :key="key" :class="field.class">
                <div>
                  <b-avatar
                    v-if="field.type=='image'"
                    :src="$_.get(item, field.key) ? $_.get(item, field.key) : require('@/assets/images/user/default-user-image.png')"
                    class="rounded-pill"
                  />

                  <div v-else-if="field.type == 'custom'">
                    <slot :name="field.key" :data="item"></slot>
                  </div>

                  <strong v-else-if="field.type == 'status'">
                    <mainstatus :status="$_.get(item, field.key)" />
                  </strong>

                  <div v-else-if="field.type == 'actions'">
                    <cell-actions
                      :showActionInList="showActionInList"
                      :cell-actions="field"
                      :data-item="item"
                    />
                  </div>

                  <div v-else-if="field.type == 'promo'">
                    <p class="m-0">
                      <span v-if="$_.get(item, field.key) > 0">P ({{ $_.get(item, field.key) }})</span>
                      <span v-else>NP</span>
                    </p>
                  </div>

                  <div v-else-if="field.type == 'offer'">
                    <p class="m-0" v-if="item.promotion_type === 'package'">{{ item.package }} for {{item.package_price_egp}} EGP</p>
                    <p class="m-0" v-else-if="item.promotion_type === 'buy_x get_y'">Buy {{ item.buy_x }}, Get {{ item.get_y }}</p>
                    <p class="m-0" v-else>{{ item.discount_price_egp }}%</p>
                  </div>

                  <div v-else-if="field.type == 'array'">
                    <span v-if="field.array_keys" >
                      <ul class="p-0">
                        <li v-for="(value, arrayKey) in arrayCellValues(item, field).slice(0,4)" :key="arrayKey">
                          <span v-if="arrayKey==3">...</span>
                          <template v-else>{{ value }}</template>
                        </li>
                      </ul>
                    </span>
                    <span v-else>
                      <span v-for="(arr, arrayKey) in $_.get(item, field.key).slice(0,3)" :key="arrayKey">
                        {{ arr }}
                        <span v-if="(arrayKey < 3)">,</span>
                      </span>
                    </span>
                  </div>

                  <div class="min-width-image-cell width-180px" v-else-if="field.type == 'multi_image'">
                    <div class="iq-media-group position-relative">
                      <b-link href="#" class="iq-media" v-for="(image, counter) in $_.get(item, field.key).slice(0,3)" :key="counter">
                        <b-img class="avatar-40" rounded="circle" fluid :src="image.file" :alt="image.name" />
                        <div v-if="($_.get(item, field.key).length > 3) && counter === 2" class="more-images text-white">{{ $_.get(item, field.key).length-3 }}+</div>
                      </b-link>
                    </div>
                  </div>

                  <div v-else-if="field.type == 'multi-text'">
                    <span v-for="(arrKey, key2) in field.key.split(',')" :key="key2">
                      <span v-if="$_.get(item, arrKey)">
                        {{ $_.get(item, arrKey) }}
                      </span>
                    </span>
                  </div>

                  <div v-else-if="field.type == 'rate'">
                    {{ $_.get(item, field.key) ? $_.get(item, field.key) : 0 }}
                  </div>

                  <div v-else-if="field.type == 'multi-currency'">
                    <ul class="p-0">
                      <li v-for="(arrKey, key3) in field.key.split(',')" :key="key3">
                        <span v-if="arrKey.includes('egp')">
                          <span v-if="$_.get(item, arrKey)">EGP {{ $_.get(item, arrKey) }}</span>
                          <span v-else>N/A</span>
                        </span>
                        <span v-else-if="arrKey.includes('euro')">
                          <span v-if="$_.get(item, 'price_euro')">
                            <span v-if="arrKey.includes('discount')&& !$_.get(item, arrKey)">
                              N/A
                            </span>
                            <span v-else>€ {{ $_.get(item, arrKey) }}</span>
                          </span>
                        </span>
                        <span v-else-if="arrKey.includes('dollar')">
                          <span v-if="$_.get(item, 'price_dollar')">
                            <span v-if="arrKey.includes('discount')&& !$_.get(item, arrKey)">
                              N/A
                            </span>
                            <span v-else>$ {{ $_.get(item, arrKey) }}</span>
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div v-else-if="field.type == 'birthDate'">
                    {{ calculateAge($_.get(item, field.key)) }}
                  </div>

                  <div v-else-if="field.type == 'validity'">
                    {{ dateDifference('', $_.get(item, field.key)) || '---' }}
                  </div>

                  <div v-else-if="field.type == 'sort'">
                    <span class="drag-handle mr-2" title="Drag to reorder">
                      <i class="las la-bars"></i>
                    </span>
                    <span>{{ (pagination.from || 1) + index }}</span>
                  </div>

                  <p v-else class="text-nowrap m-0">
                    <span v-if="$_.get(item, field.key)">
                      {{ $_.get(item, field.key).length > limitOfChar ? $_.get(item, field.key).substring(0,limitOfChar) + '...' : $_.get(item, field.key) }}
                    </span>
                    <span v-else>---</span>
                  </p>
                </div>
              </td>
            </tr>
          </draggable>
          <tbody v-if="!listOfData.length">
            <tr>
              <td :colspan="fields.length" class="text-center py-4">No records found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-if="paginationFlag"
      v-model="pagination.current_page"
      :total-rows="pagination.total"
      :per-page="pagination.per_page"
      first-number
      last-number
      class="mb-3 mt-1 mt-sm-0"
      prev-class="prev-item"
      next-class="next-item"
      align="right"
      @input="getListData"
    >
    </b-pagination>
  </div>
</template>

<script>
import Bus from '@/eventBus'
import mainstatus from './status'
import mainService from '@/services/main'
import cellActions from './cellActions'
import changeStatus from './changeStatus'
import draggable from 'vuedraggable'
import { dateDifference } from '@/Helpers/helper'
import { core } from '@/config/pluginInit'
export default {
  components: {
    mainstatus,
    cellActions,
    changeStatus,
    draggable
  },
  props: {
    showActionInList: {
      type: Boolean,
      default: false
    },
    limitOfChar: {
      default: 20,
      required: false
    },
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: [Array, Object],
      required: false
    },
    list_url: {
      type: String
    },
    additionalUrl: {
      type: String
    },
    params: {
      type: [Object, Array]
    },
    reloadData: {
      type: Boolean,
      default: false
    },
    paginationFlag: {
      type: Boolean,
      default: true
    },
    headVariant: {
      type: String,
      default: ''
    },
    arrangeMode: {
      type: Boolean,
      default: false
    },
    service_type: {
      type: String,
      default: ''
    },
    customFilter: {
      type: Object
    }
  },
  data () {
    return {
      transProps: {
        name: 'flip-list'
      },
      listOfData: [],
      total: 0,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 10,
        from: 1,
        to: 10
      },
      loadingTable: false,
      internalReload: false,
      moreImages: 2,
      autoCount: 1,
      savingSort: false
    }
  },
  watch: {
    items: {
      handler(val) {
        if (Array.isArray(val) && val.length) {
          this.listOfData = val
          this.loadingTable = false
          this.dimInactive()
        } else if (Array.isArray(val) && this.loadingTable) {
          this.listOfData = []
          this.loadingTable = false
        }
      },
      immediate: true,
      deep: true
    },
    params () {
      this.getListData()
    },
    customFilter: {
      handler () {
        this.getListData()
      },
      deep: true
    },
    reloadData (val) {
      this.internalReload = val
    },
    internalReload (val) {
      if (val) {
        this.listOfData = []
        this.getListData()
      }
    }
  },
  created () {
    this.getListData()
  },
  methods: {
    dateDifference,
    arrayCellValues (item, field) {
      const rows = field.key.split(',').reduce((all, key) => all.concat(this.$_.get(item, key.trim()) || []), [])

      return rows
        .map(row => field.array_keys
          .map(arrayKey => this.$_.get(row, arrayKey))
          .filter(value => value !== null && value !== undefined && value !== '')
          .join(' '))
        .filter(value => value)
    },
    async getListData () {
      this.listOfData = []
      this.total = 0
      let filters = {}
      if (this.params) {
        this.params.map(data => {
          filters[data.name] = data.checked
        })
      }
      this.loadingTable = true
      let List = []
      if (this.customFilter) {
        filters = this.customFilter
      }
      const query = { ...filters }
      if (this.paginationFlag) {
        query.page = this.pagination.current_page
      }
      if (!Array.isArray(this.items)) {
        List = await
        mainService.listDataTabl(
          `${this.list_url}${this.additionalUrl ? this.additionalUrl : ''}`,
          query
        )
        if (List.data?.data?.data) {
          this.listOfData = List.data?.data?.data
          this.total = List.data?.data?.total
          this.pagination = {
            current_page: Number(List.data?.data?.current_page) || this.pagination.current_page,
            per_page: Number(List.data?.data?.per_page) || this.pagination.per_page,
            total: Number(List.data?.data?.total) || 0,
            from: List.data?.data?.from,
            to: List.data?.data?.to
          }
        } else {
          this.listOfData = List.data?.data
        }
      } else {
        this.listOfData = this.items
      }
      this.loadingTable = false
      this.internalReload = false
      this.dimInactive()
    },
    dimInactive () {
      this.listOfData.forEach(row => {
        row._rowVariant = row.status === 'inactive' ? 'secondary' : ''
      })
    },
    sortChanged (data) {
      this.$emit('sortChanged', data)
    },
    onDragChange (event) {
      if (!event.moved) {
        return
      }
      if (!this.service_type) {
        core.showSnackbar('error', 'This table is missing its sort type')
        return
      }
      const { oldIndex, newIndex } = event.moved

      const payload = new URLSearchParams()
      payload.append('type', this.service_type)
      this.listOfData.forEach(row => payload.append('sort[]', row.id))

      this.savingSort = true
      mainService.sort(payload).then(res => {
        core.showSnackbar('success', res.data.message)
      }).catch(() => {
        const [row] = this.listOfData.splice(newIndex, 1)
        this.listOfData.splice(oldIndex, 0, row)
      }).finally(() => {
        this.savingSort = false
      })
    },
    changeSort (id, type, sort) {
      mainService.sort({ id, type, sort }).then(res => {
        core.showSnackbar('success', res.data.message)
        this.internalReload = true
      })
    },
    changeStatus (data) {
      mainService.changeStatus(data.payload, data.postKey).then(res => {
        core.showSnackbar('success', res.data.message)
        const IndexRow = this.listOfData.findIndex(row => row.id === data.data.item.id)
        if (this.listOfData[IndexRow].status === 'active') {
          this.listOfData[IndexRow].status = 'inactive'
          this.listOfData[IndexRow]._rowVariant = 'secondary'
        } else if (this.listOfData[IndexRow].status === 'inactive') {
          this.listOfData[IndexRow].status = 'active'
          this.listOfData[IndexRow]._rowVariant = ''
        }
      }).catch(() => {
        if (data.revert) data.revert()
      })
    },
    calculateAge (date) {
      if (!date) return '---'

      const today = new Date()
      const birthDate = new Date(date)
      let age = today.getFullYear() - birthDate.getFullYear()
      const m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    }
  },
  mounted () {
    this._reloadAfterDelete = () => { this.internalReload = true }
    Bus.$on('reloadTableAfterDelete', this._reloadAfterDelete)
  },
  beforeDestroy () {
    Bus.$off('reloadTableAfterDelete', this._reloadAfterDelete)
  }
}
</script>
<style>
table#table-transition-example .flip-list-move {
  transition: transform 0.5s;
}
.sort-field {
  width: 50px !important;
  border: none !important;
  border-bottom: 1px dashed grey !important;
}
.drag-handle {
  cursor: grab;
  display: inline-flex;
  align-items: center;
}
.dragging {
  background-color: rgba(0, 0, 0, 0.04);
}
#table-transition-example > thead > tr > th:nth-child(1) {
  text-align: center
}
</style>
